import { useEffect, useState } from "react";
import { useLocation } from "@tanstack/react-router";
import { cn, generateTextShadow } from "@/lib/utils";
import configs from "@/lib/configs";

const BYPASS_STORAGE_KEY = "cfl:maintenance-bypass";
const BYPASS_QUERY_PARAM = "CxDev";

const ALLOWED_ROUTES = ["/", "/arena"];

function isAllowedRoute(pathname: string) {
  return ALLOWED_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}

export function MaintenanceOverlay() {
  const location = useLocation();
  const [isBypassed, setIsBypassed] = useState(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(BYPASS_STORAGE_KEY) === "true";
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(BYPASS_QUERY_PARAM) === "1") {
      localStorage.setItem(BYPASS_STORAGE_KEY, "true");
      setIsBypassed(true);
      params.delete(BYPASS_QUERY_PARAM);
      const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  if (
    !configs?.MAINTENANCE?.enabled ||
    isBypassed ||
    isAllowedRoute(location.pathname)
  ) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const message =
    configs.MAINTENANCE.message ??
    "We're currently performing maintenance. Please check back soon.";

  return (
    <div className="fixed inset-0 z-[9999] h-[100svh] text-white w-full flex flex-col overflow-x-hidden">
      <div
        className={cn(
          "relative flex-1 mx-auto w-full flex flex-col overflow-x-hidden bg-[#1D2A52]",
        )}
      >
        <div className="flex flex-1 flex-col items-center justify-center gap-2 mx-4 text-center">
          <img
            src="/assets/maintenance.png"
            className="h-auto w-68 sm:w-72"
            alt="Maintenance"
          />

          <h1
            className="text-4xl sm:text-5xl text-[#cd4223] uppercase text-center sm:space-x-3"
            style={{
              fontFamily: "DeadRevolverDisplay",
              textShadow: generateTextShadow(0.4),
            }}
          >
            <span>CFL IS Under Maintenance</span>
          </h1>

          <div className="text-base text-center flex flex-col gap-1 mx-2">
            {/* <p className="text-base">{message}</p> */}
            <p className="text-xs sm:text-sm opacity-60 mt-2 sm:mt-0">
              Follow us on{" "}
              <a
                href="https://x.com/cfldotfun"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-[#109ffe]"
              >
                Twitter
              </a>{" "}
              and join our{" "}
              <a
                href="https://discord.com/invite/GQuP7ekfF9"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-[#109ffe]"
              >
                Discord
              </a>{" "}
              for more updates
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
